import { ReadonlyURLSearchParams } from 'next/navigation'
import { getSimulationTimestampDataStorage } from '@/modules/simulator/functions'

const DAY = 86400000

const isReaccessingMESimulation = (
  searchParams: ReadonlyURLSearchParams | null
) => {
  const forceNewSimulation = searchParams?.get('forceNew')
  const lastSimulationTimestamp = getSimulationTimestampDataStorage()

  if (!lastSimulationTimestamp || forceNewSimulation) {
    return false
  }

  const today = Date.now()
  const lastSimulationDate = new Date(lastSimulationTimestamp).getTime()
  const daysSinceLastSimulation = (today - lastSimulationDate) / DAY

  return daysSinceLastSimulation <= 30
}

export { isReaccessingMESimulation }
